'use es6';

import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import { getReportDefinition } from 'reporting-data/report/reportGetters';
import { isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import SnowflakeFilterEditor from 'reporting-snowflake/relational/modify/filters/SnowflakeFilterEditor';
import { RelationalReport } from 'reporting-snowflake/relational/schema/report-records';
import { EVENTS } from 'reporting-ui-components/lib/events';
import useCloneTracker from 'reporting-ui-components/lib/useCloneTracker';
import { ReportType } from 'reporting-ui-components/types/ReportTypes';
import { getIsUngatedForSRVLiteEditting, getIsUngatedToSRVLiteEditingSnowflake } from 'reporting-enablement/constants/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const SnowflakeEditor = ({
  report,
  onChange,
  appUsageTracker
}) => {
  const reportDefinition = getReportDefinition(report);
  const relationalReport = RelationalReport(reportDefinition);
  const usageTracker = useCloneTracker(appUsageTracker);
  return /*#__PURE__*/_jsx(SnowflakeFilterEditor, {
    schema: "report",
    definition: relationalReport,
    onChange: filtering => {
      usageTracker.track(EVENTS.changeSrvSnowflakeFilters);
      onChange(report.setIn(['reportDefinition', 'filtering'], fromJS(filtering.toJS())));
    },
    onUpdateEventDateInterval: eventDateInterval => {
      usageTracker.track(EVENTS.changeSrvSnowflakeFilters);
      onChange(report.setIn(['reportDefinition', 'eventDateInterval'], eventDateInterval));
    }
  });
};
SnowflakeEditor.propTypes = {
  appUsageTracker: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  report: ReportType.isRequired
};
SnowflakeEditor.isUsableForReport = (report, gates) => {
  return isRelationalReport(report) && !getIsUngatedForSRVLiteEditting(gates) && !getIsUngatedToSRVLiteEditingSnowflake(gates);
};
export default SnowflakeEditor;